import { ConfirmingRequest } from 'lib/types/models';

import { ConfirmingCheckboxesState } from '../hooks/useConfirmingCheckboxes';
import { ConfirmingExportRequest } from '../types/ConfirmingExportRequest';

export interface BuildConfirmingRequestOptions {
  selectedRequest: ConfirmingRequest;
  checkboxes: ConfirmingCheckboxesState;
}

export const buildConfirmingRequest = (
  options: BuildConfirmingRequestOptions,
): ConfirmingExportRequest => {
  const { selectedRequest, checkboxes } = options;

  return {
    ...selectedRequest,
    ...checkboxes,
    // Incluir mensajes del chat seleccionados solo si showChatAsObservations es true
    ...(checkboxes.showChatAsObservations &&
      checkboxes.selectedChatMessagesObjects &&
      checkboxes.selectedChatMessagesObjects.length > 0 && {
        selectedChatMessages: checkboxes.selectedChatMessagesObjects,
      }),
  } as ConfirmingExportRequest;
};
